import Hotjar from '@hotjar/browser';
import { HOTJAR_CONFIG } from '../consts/hotjar';

export const shouldEnableHotjar = (user: any): boolean => {
    if (!user || !user.namespaces) {
    return false;
  }

  if (HOTJAR_CONFIG.blacklistedDomains
    .some((domain: string) => user.email.includes(domain))) {
    return false;
  }

  const hasWhitelistedNamespace = user.namespaces.some((namespace: string) =>
    HOTJAR_CONFIG.whitelistedNamespaces.includes(namespace)
  );

  if (hasWhitelistedNamespace) {
    return true;
  }

  // for adding school whitelist check when/if needed
  // if (user.schools && user.schools.some(school => 
  //   HOTJAR_CONFIG.whitelistedSchoolIds.includes(school.id)
  // )) {
  //   return true;
  // }
  // 
  return false;
};

export const initHotjar = (user: any): void => {
  if (shouldEnableHotjar(user)) {
    try {
      Hotjar.init(HOTJAR_CONFIG.siteId, HOTJAR_CONFIG.version);
      console.log('hotjar initialized for user:', user.pk);
    } catch (error) {
      console.error('failed to initialize hotjar:', error);
    }
  }
};
